import _ from 'lodash';

import { addTraits } from 'src/api';

export const getToken = state => addTraits(state.auth.token);
export const getSettings = state => _.get(state, 'auth.settings.data', {});
